import { render, staticRenderFns } from "./normalRelation.vue?vue&type=template&id=04431c87&scoped=true&"
import script from "./normalRelation.vue?vue&type=script&lang=js&"
export * from "./normalRelation.vue?vue&type=script&lang=js&"
import style0 from "./normalRelation.vue?vue&type=style&index=0&id=04431c87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04431c87",
  null
  
)

export default component.exports